/** @format */

import React from 'react';

import {add} from 'date-fns';

import DatePicker from 'react-datepicker';

import {DateRangeContainer, DatePickerWrapper, DateSeparator, DatePickerIcon} from '../styles';
import {DateRangeFieldProps} from '../../../types';
import {MIN_CALENDAR_RANGE_DAYS} from '../constants';

const DateRangeField: React.FC<DateRangeFieldProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabled = false,
}) => {
  const maxEndDate = add(new Date(), {days: -1});
  const maxStartDate = add(new Date(), {days: -MIN_CALENDAR_RANGE_DAYS});

  return (
    <DateRangeContainer>
      <DatePickerWrapper>
        <DatePickerIcon />
        <DatePicker
          selected={startDate}
          onChange={onStartDateChange}
          placeholderText='От'
          portalId='root'
          dateFormat='dd.MM.yyyy'
          maxDate={maxStartDate}
          disabled={disabled}
        />
      </DatePickerWrapper>
      <DateSeparator />
      <DatePickerWrapper>
        <DatePickerIcon />
        <DatePicker
          selected={endDate}
          onChange={onEndDateChange}
          placeholderText='До'
          portalId='root'
          dateFormat='dd.MM.yyyy'
          maxDate={maxEndDate}
          disabled={disabled}
        />
      </DatePickerWrapper>
    </DateRangeContainer>
  );
};

export default DateRangeField;
